import { render } from "./App.vue?vue&type=template&id=3b03262a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b03262a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\SMFBackstageBase\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b03262a"]])

export default __exports__